
interface RelatedModelsProps {
  currentModelId: number;
  category: string;
}

export default function RelatedModels({ currentModelId, category }: RelatedModelsProps) {
  const relatedModels = [
    {
      id: 2,
      name: 'Phoenix Miniature',
      image: 'https://public.readdy.ai/ai/img_res/55ce261509521696f6b7e6008a123ee4.jpg',
      price: 28.99,
      rating: 4.7,
      printTime: '10 hours'
    },
    {
      id: 3,
      name: 'Wizard Miniature',
      image: 'https://readdy.ai/api/search-image?query=3D%20printed%20wizard%20miniature%20figure%20with%20robes%20and%20staff%2C%20detailed%20fantasy%20character%20model%2C%20high%20quality%20resin%20print%20with%20fine%20details%2C%20professional%20lighting%20on%20white%20background&width=300&height=300&seq=wizard-mini&orientation=squarish',
      price: 22.50,
      rating: 4.9,
      printTime: '7 hours'
    },
    {
      id: 4,
      name: 'Unicorn Miniature',
      image: 'https://readdy.ai/api/search-image?query=3D%20printed%20unicorn%20miniature%20with%20detailed%20mane%20and%20horn%2C%20elegant%20fantasy%20creature%20model%20in%20white%20resin%2C%20professional%20product%20photography%20with%20soft%20lighting&width=300&height=300&seq=unicorn-mini&orientation=squarish',
      price: 26.75,
      rating: 4.8,
      printTime: '9 hours'
    },
    {
      id: 5,
      name: 'Griffin Miniature',
      image: 'https://readdy.ai/api/search-image?query=3D%20printed%20griffin%20miniature%20with%20eagle%20head%20and%20lion%20body%2C%20mythical%20creature%20model%20with%20detailed%20feathers%20and%20fur%20texture%2C%20high%20quality%20resin%20print%20on%20white%20background&width=300&height=300&seq=griffin-mini&orientation=squarish',
      price: 31.99,
      rating: 4.6,
      printTime: '11 hours'
    }
  ].filter(model => model.id !== currentModelId);

  return (
    <section className="py-16">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Related Models</h2>
          <p className="text-lg text-gray-600">
            Discover more models from the {category} collection
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
          {relatedModels.map((model) => (
            <div key={model.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <div className="aspect-square overflow-hidden">
                <img
                  src={model.image}
                  alt={model.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <h3 className="font-bold text-gray-900 mb-2">{model.name}</h3>
                
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <i 
                      key={i} 
                      className={`ri-star-${i < Math.floor(model.rating) ? 'fill' : 'line'} text-yellow-400 text-sm`}
                    ></i>
                  ))}
                  <span className="text-xs text-gray-600 ml-1">{model.rating}</span>
                </div>

                <div className="flex justify-between items-center mb-3">
                  <span className="text-lg font-bold text-blue-600">${model.price}</span>
                  <span className="text-xs text-gray-500">{model.printTime}</span>
                </div>

                <div className="flex gap-2">
                  <button className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                    View Details
                  </button>
                  <button className="w-10 h-10 flex items-center justify-center border border-gray-200 hover:border-blue-600 hover:text-blue-600 rounded-lg transition-colors cursor-pointer">
                    <i className="ri-qr-code-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer">
            View All {category} Models
          </button>
        </div>
      </div>
    </section>
  );
}